import { UnderwearAreaChart } from '@/components/dashboard/underwear/underwear-area-chart';

export const UnderwearDashboard = () => {
  return <UnderwearAreaChart />;
};
